<div class="progress-bar-container">
  <div
    class="progress-bar"
    [style.width.%]="progressPercent"
    [style.margin-left.%]="progressStartAtPercent"
    [style.backgroundColor]="color"></div>
</div>
